import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, _STATE_COURSE_FEATURE_KEY } from './course.reducer';

//Lookup the 'StateCourse' feature state managed by NgRx
export const getStateCourseState = createFeatureSelector<State>(
	_STATE_COURSE_FEATURE_KEY,
);

export const getStateCourse = createSelector(
	getStateCourseState,
	(state: State) => state.course,
);

export const getStateUniversity = createSelector(
	getStateCourseState,
	(state: State) => state.university,
);

export const getStateClearingCourse = createSelector(
	getStateCourseState,
	(state: State) => state.clearingCourse,
);

export const getStateClearingUniversity = createSelector(
	getStateCourseState,
	(state: State) => state.clearingUniversity,
);

export const getStateCourseIsLoading = createSelector(
	getStateCourseState,
	(state: State) => state.isCourseLoading,
);

export const getStateUniIsLoading = createSelector(
	getStateCourseState,
	(state: State) => state.isUniLoading,
);

export const getCourseError = createSelector(
	getStateCourseState,
	(state: State) => state.error,
);
